import { render, staticRenderFns } from "./custom-form-text.vue?vue&type=template&id=62c4eeb6&scoped=true"
import script from "./custom-form-text.vue?vue&type=script&lang=js"
export * from "./custom-form-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4eeb6",
  null
  
)

export default component.exports